import { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";

class SignalRService {
  constructor() {
    this.connection = null;
    this.listeners = {};
  }

  async initConnection() {
    if (this.connection) return;

    this.connection = new HubConnectionBuilder()
      .withUrl(process.env.VUE_APP_ROOT_API + '/hub', {
        accessTokenFactory: () => {
          return localStorage.getItem("auth-token");
        }
      })
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();
      this.connection.serverTimeoutInMilliseconds = 60000; // 60 saniye
      this.connection.keepAliveIntervalInMilliseconds = 30000; // 30 saniye

    this.connection.onreconnecting((error) => {
      console.log(`Bağlantı kesildi. Yeniden bağlanmaya çalışılıyor. Hata: ${error}`);
    });

    this.connection.onreconnected((connectionId) => {
      console.log(`Bağlantı yenilendi. Yeni bağlantı ID'si: ${connectionId}`);
    });

    this.connection.onclose((error) => {
      console.log(`Bağlantı kapatıldı. Hata: ${error}`);
    });

    try {
      await this.connection.start();
      console.log("SignalR connection established successfully");
    } catch (err) {
      console.error("SignalR connection error: ", err);
    }
  }

  // Add a listener for an event
  on(eventName, callback) {
    if (!this.connection) {
      console.error("SignalR connection not initialized");
      return;
    }

    // Add to local registry
    if (!this.listeners[eventName]) {
      this.listeners[eventName] = [];

      // Register the event on the connection
      this.connection.on(eventName, (data) => {
        // Call all registered callbacks for this event
        if (this.listeners[eventName]) {
          this.listeners[eventName].forEach(cb => cb(data));
        }
      });
    }

    // Add callback to registry
    this.listeners[eventName].push(callback);
  }

  // Remove a listener
  off(eventName, callback) {
    if (!this.listeners[eventName]) return;

    const index = this.listeners[eventName].indexOf(callback);
    if (index !== -1) {
      this.listeners[eventName].splice(index, 1);
    }

    // If no listeners left for this event, remove the SignalR listener
    if (this.listeners[eventName].length === 0) {
      this.connection.off(eventName);
      delete this.listeners[eventName];
    }
  }

  // Invoke a method on the server
  async invoke(methodName, ...args) {
    if (!this.connection) {
      console.error("SignalR connection not initialized");
      return;
    }

    try {
      return await this.connection.invoke(methodName, ...args);
    } catch (err) {
      console.error(`Error invoking method ${methodName}:`, err);
      throw err;
    }
  }
}

// Create a singleton instance
const signalRService = new SignalRService();

export default signalRService;
